import { render, staticRenderFns } from "./ViewPruning.vue?vue&type=template&id=0748582e&scoped=true&lang=html&"
import script from "./ViewPruning.vue?vue&type=script&lang=js&"
export * from "./ViewPruning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748582e",
  null
  
)

export default component.exports